import React from 'react';
import { useStyletron } from 'baseui';
import { CustomColumn, StringColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	featureName: 'featureName',
	featureId: 'featureId',
	segmentName: 'segmentName',
	segmentId: 'segmentId',
	enabled: 'enabled',
	updatedBy: 'updatedBy',
	updatedAt: 'updatedAt',
	createdBy: 'createdBy',
	createdAt: 'createdAt'
};

export const columnConfigs = [
	StringColumn({
		title: 'Feature Name',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.featureName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Feature ID',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.featureId] || EMPTY_STRING
	}),
	StringColumn({
		title: 'SegmentName',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.segmentName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Segment ID',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.segmentId].toString() || EMPTY_STRING
	}),
	CustomColumn({
		title: 'Enabled',
		mapDataToValue: (data: any) => data[COL_NAMES.enabled] || EMPTY_STRING,
		maxWidth: 100,
		renderCell: (params: any) => {
			const { value } = params;
			const text: string = value ? 'YES' : 'NO';
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: value ? 'lightgreen' : 'lightcoral',
						height: '30px',
						width: '80%',
						textAlign: 'center'
					})}>
					{text}
				</div>
			);
		}
	}),
	StringColumn({
		title: 'Updated By',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.updatedBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Updated At',
		maxWidth: 120,
		columnName: COL_NAMES.updatedAt
	}),
	StringColumn({
		title: 'Created By',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Created At',
		maxWidth: 120,
		columnName: COL_NAMES.createdAt
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};
